<template>
  <el-form-item v-bind="getFormItemProps" ref="formItem" v-if="isShowFormItem">
    <slot name="label" slot="label">
      {{ label }}
      <el-tooltip effect="dark" :content="toolTip" placement="top" v-if="toolTip">
        <span class="el-icon-question" style="margin-left: 8px"/>
      </el-tooltip>
    </slot>
    <slot slot="error" slot-scope="error" name="error" :error="error"/>
    <el-date-picker v-bind="datePickerProps"
                    :value="value"
                    :style="pickerStyle"
                    :class="pickerClass"
                    ref="datePicker"
                    @input="onInput"
                    v-on="$listeners"/>
    <!-- 右边区域插槽 -->
    <slot name="right"/>
  </el-form-item>
  <el-date-picker v-bind="datePickerProps"
                  v-else
                  :value="value"
                  :style="pickerStyle"
                  :class="pickerClass"
                  ref="datePicker"
                  @input="onInput"
                  v-on="$listeners"/>
</template>

<script>
import formItemProps from "../mixin/form-item"
import { parseDate, formatDate } from "element-ui/lib/utils/date-util"
import { DATE_FORMAT_BY_TYPE, DATE_PLACEHOLDER_BY_TYPE, getDisabledTime, getPickerOptions } from "./util"

export default {
    name: "ZjDatePicker",
    mixins: [formItemProps],
    props: {
        type: {
            type: String,
            default: "date"
        },
        size: String,
        format: String,
        valueFormat: String,
        readonly: Boolean,
        placeholder: String,
        startPlaceholder: String,
        endPlaceholder: String,
        prefixIcon: String,
        clearIcon: {
            type: String,
            default: "el-icon-circle-close"
        },
        name: {
            default: "",
            type: String
        },
        disabled: {
            type: [Boolean, String],
            validator (val) {
                return [true, false, undefined, "before", "after"].includes(val)
            }
        },
        clearable: {
            type: Boolean,
            default: true
        },
        id: {
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        },
        align: {
            type: String,
            default: "right"
        },
        value: {},
        defaultValue: {},
        defaultTime: {},
        rangeSeparator: {
            default: "-"
        },
        pickerOptions: {},
        unlinkPanels: Boolean,
        validateEvent: {
            type: Boolean,
            default: true
        },
        pickerStyle: {},
        pickerClass: {}
    },
    data (vm) {
        return {
            options: vm.getPickerOptions() // pickerOptions
        }
    },
    computed: {
        datePickerProps () {
            const {
                type,
                label,
                placeholder,
                rangeSeparator,
                startPlaceholder,
                endPlaceholder,
                disabled,
                valueFormat,
                size,
                format,
                readonly,
                prefixIcon,
                clearIcon,
                editable,
                align,
                defaultValue,
                defaultTime,
                unlinkPanels,
                validateEvent,
                clearable
            } = this
            return {
                type,
                placeholder: placeholder || type.includes("range") ? undefined : "请选择" + label,
                rangeSeparator: rangeSeparator || "至",
                startPlaceholder: startPlaceholder || Array.isArray(DATE_PLACEHOLDER_BY_TYPE[type]) ? DATE_PLACEHOLDER_BY_TYPE[type][0] : "",
                endPlaceholder: endPlaceholder || Array.isArray(DATE_PLACEHOLDER_BY_TYPE[type]) ? DATE_PLACEHOLDER_BY_TYPE[type][1] : "",
                valueFormat: valueFormat || DATE_FORMAT_BY_TYPE[type],
                disabled: typeof disabled === "boolean" ? disabled : false,
                pickerOptions: this.options,
                size,
                format,
                readonly,
                prefixIcon,
                clearIcon,
                editable,
                align,
                defaultValue,
                defaultTime,
                unlinkPanels,
                validateEvent,
                clearable
            }
        }
    },
    methods: {
        onInput (val) {
            const { type, disabled } = this
            if (type === "datetime") {
                if (typeof disabled === "string") {
                    const isCurrentDay = formatDate(parseDate(val, DATE_FORMAT_BY_TYPE[type])) === formatDate(new Date())
                    if (isCurrentDay) {
                        this.$set(this.options, "selectableRange", getDisabledTime(disabled))
                    } else {
                        this.$set(this.options, "selectableRange", [])
                    }
                }
            }
            this.$emit("input", val)
        },
        // 获取时间快捷键
        getPickerOptions () {
            const { disabled, type, pickerOptions = Object.create(null) } = this
            if (disabled === true || (/^(month)|(week)/.test(type))) return undefined
            const isRange = type.includes("range")
            if (!disabled) {
                const getShortcuts = (disabled, startIndex = 0, endIndex = -4) => getPickerOptions(isRange, disabled).shortcuts.slice(startIndex, endIndex)
                const shortcuts = [...getShortcuts("after"), ...getShortcuts("before", 1)]
                return Object.assign({ shortcuts }, pickerOptions)
            }
            return Object.assign(getPickerOptions(isRange, disabled), pickerOptions)
        },
        // 获取datepicker实例
        getDatePickerInstance () {
            return this.$refs.datePicker
        }
    }
}
</script>
